<img alt="" src="assets/images/svgs/empty.svg" />
